import axios from "axios";

let baseURL = "https://localhost:7201/api"; 

const hostname = window.location.hostname;

if (hostname === "172.30.11.101") {
  baseURL = "https://172.30.11.101/api";
} 
else if (hostname === "cpanel") {
  baseURL = "https://cpanel/api";
}
else if (hostname === "172.30.12.17") {
  baseURL = "https://172.30.12.17/api";
} 
else if (hostname === "172.30.12.18") {
  baseURL = "https://172.30.12.18/api";
}
else if (hostname === "87.107.111.33") {
  baseURL = "https://87.107.111.33/api";
}
else if (hostname === "panel.doosheh.com") {
  baseURL = "https://panel.doosheh.com/api";
}

// ساخت axios instance
const axiosInstance = axios.create({
  baseURL,
  withCredentials: true,
});

// اضافه کردن توکن
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// هندل 401
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
